import type { CaptureIssue } from '../lib/capture';

import { useT } from '../lib/i18n';

/**
 * What the light meter noticed, said once and dismissible.
 *
 * Phrased as what to do rather than as what is wrong: "move to a window" is
 * actionable where "underexposed" is a diagnosis. The upload has already
 * happened — this is the nudge to take a better one, not a refusal of the
 * one taken.
 */
export function CaptureNotes({
  notes,
  onDismiss,
}: {
  notes: Array<{ name: string; issues: CaptureIssue[] }>;
  onDismiss: () => void;
}) {
  const t = useT();
  return (
    <div className="banner stack stack--sm">
      <span>{t('capture.heading', { n: notes.length })}</span>
      <ul className="stack stack--sm">
        {notes.map((note) => (
          <li key={note.name} className="faint">
            <strong>{note.name}</strong> — {note.issues.map((issue) => t(`capture.${issue}`)).join(' · ')}
          </li>
        ))}
      </ul>
      <button type="button" className="btn btn--ghost btn--sm" onClick={onDismiss}>
        {t('capture.dismiss')}
      </button>
    </div>
  );
}
